export default __webpack_public_path__ + "static/017-lightbulb-70af89b2e4a43ce5b082a3a62d2b58a2.svg";